module.exports = __webpack_public_path__ + "static/media/cupcake-line.09677dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/cupcake-line.jpg
// module id = 798
// module chunks = 0